import React, {
    Fragment,
    useEffect,
    useState
} from 'react';
import {
    Chart,
    CommonSeriesSettings,
    Series,
    Legend,
    SeriesTemplate
} from 'devextreme-react/chart';
import PieChart, {
    Legend as PieChartLegend,
    Series as PieChartSeries,
    Tooltip,
    Label,
    Connector,
    Export
} from 'devextreme-react/pie-chart';
import List from 'devextreme-react/list';
import 'font-awesome/css/font-awesome.min.css';
import Button from 'devextreme-react/button';
import DropDownButton from 'devextreme-react/drop-down-button';
import {ProgressBar} from 'devextreme-react/progress-bar';
import Calendar from 'devextreme-react/calendar';
import {TabPanel, Item} from 'devextreme-react/tab-panel';
import DataGrid, {Sorting, Column} from 'devextreme-react/data-grid';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import DashboardApi from '../../../api/dashboard';
import sessions from '../../../sessions';
import './index.scss';

const Customers = (props) => {
    return (
        <Fragment>
            <DataGrid
                id="customerGrid"
                dataSource={props.dataProduct}
                columnAutoWidth={true}
                showBorders={false}>
                <Sorting mode={'none'}/>
                <Column dataField={'id'} caption={'No'}/>
                <Column dataField={'name'}/>
                <Column dataField={'totalAmount'}/>
            </DataGrid>
        </Fragment>
    );
}

const NotificationWrap = (data) => {
    const note = `Awaiting shipment for ${data.store} with order no ${data.orderNo}`;
    return (
        <div id={data.id} className={'notification-list'}>
            <div className={'notification-wrap'}>
                <p className={'mb-2 mt-2'}>{data.paidDate}</p>
                <div><i className={'fa fa-bell-o'}/></div>
            </div>
            <div className={'note'}>
                <p>{note}</p>
            </div>
        </div>
    )
}

const StoresProgressBar = (props) => {
    const items = props.items;
    const totalSales = [];
    
    items.forEach(item => (totalSales.push(item.totalAmount)))

    const StoresProgressBar = items.map(item => {
        const maxValue = Math.max(...totalSales);
        const value = Math.ceil((item.totalAmount / maxValue) * 100)
        return (
            <Fragment>
                <div className={'progress-area'}>
                    <div className={'flex-row flex-between'}>
                        <p>{item._id}</p>
                        <p>${item.totalAmount.toFixed(2)}</p>
                    </div>
                    <div >
                        <ProgressBar
                            min={0}
                            max={100}
                            value={value}
                            hoverStateEnabled={false}
                            showStatus={false}/>
                    </div>
                </div>
            </Fragment>
        )
    });

    return (
        <Fragment>
            {StoresProgressBar}
        </Fragment>
    );
}

const Overview = () => {
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const [orderSummary, setOrderSummary] = useState([])
    const [salesByStore, setSalesByStore] = useState([])
    const [totalOrderWeekMonth, setTotalOrderWeekMonth] = useState([])
    const [topProduct, setTopProduct] = useState([])
    const [shipmentByCarrier, setShipmentByCarrier] = useState([])
    const [currentDate, setCurrentDate] = useState(new Date())
    const [loadingIndicator, setLoadingIndicator] = useState(false)
    const [dataUpcomingEvent, setDataUpcomingEvent] = useState([])
    
    useEffect(() => {
        const fetchData = async () => {
            await DashboardApi.getOrderSummary(userId,auth)
                .then(res => setOrderSummary(res.data.data))
            await DashboardApi.getSalesByStore(userId,auth)
                .then(res => setSalesByStore(res.data.data))     
            await DashboardApi.getTotalOrderByWeekMonth(userId,auth)
                .then(res => setTotalOrderWeekMonth(res.data.data))
            await DashboardApi.getTopProduct(userId,auth)
                .then(res => setTopProduct(res.data.data))
            await DashboardApi.getShipmentByCarrier(userId,auth)
                .then(res => setShipmentByCarrier(res.data.data))
        }
        fetchData()        
    }, [])
    
    //console.log('totalOrderWeekMonth', totalOrderWeekMonth)

    function customizeTooltip(arg) {
        return {
            text: `${arg
                .valueText} - ${ (arg.percent * 100)
                .toFixed(2)}%`
        };
    }

    const calendarValueChanged = async (e) => {
        setLoadingIndicator(true)
        setCurrentDate(e.value)
        // console.log('calendar', e)
        await DashboardApi.getUpcomingEvent(userId, new Date(e.value).toISOString())
            .then((res) => {
                if(res.data.success === true) {
                    setDataUpcomingEvent(res.data.data)
                }
                setLoadingIndicator(false)
            })
    }    

    return (
        <React.Fragment>
            <div>
                <h4 className={'content-block'}>Overview</h4>
            </div>
            <div className={'flex-row content-block'}>
                <div className={'content-bar'}>
                    <div className={'user-area'}>
                        <div className={'user-img'}></div>
                        <div>
                            <div className={'user-name'}></div>
                        </div>
                    </div>
                    <div className={'summary mb-2'}>
                        <TabPanel>
                            <Item className={'item'} title="Summary">
                                <div className={'flex-row flex-center'}>
                                    <Button className={'order-group-link'} stylingMode={'outlined'} width={170}>
                                        <div className={'order-item'}>
                                            <div className={'img-box'}>
                                                <i className="fas fa-clipboard-list fa-2x dark-blue-icon"></i>
                                            </div>
                                            <div className={'statistic-no'}>
                                                <div>
                                                    <h5>{(orderSummary.newOrder === undefined) ? 0 : orderSummary.newOrder}</h5>
                                                </div>
                                                <div>
                                                    <p>New Orders</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Button>
                                    <Button className={'order-group-link'} stylingMode={'outlined'} width={170}>
                                        <div className={'order-item'}>
                                            <div className={'img-box'}>
                                                <i className="fas fa-box fa-2x dark-blue-icon"></i>
                                            </div>
                                            <div className={'statistic-no'}>
                                                <div>
                                                    <h5>{(orderSummary.readyToShip === undefined) ? 0 : orderSummary.readyToShip}</h5>
                                                </div>
                                                <div>
                                                    <p>Ready To Ships</p>
                                                </div>
                                            </div>
                                            <div></div>
                                        </div>
                                    </Button>
                                    <Button className={'order-group-link'} stylingMode={'outlined'} width={170}>
                                        <div className={'order-item'}>
                                            <div className={'img-box'}>
                                                <i className="fas fa-truck-loading fa-2x dark-blue-icon"></i>
                                            </div>
                                            <div className={'statistic-no'}>
                                                <div>
                                                    <h5>{(orderSummary.orderShipped === undefined) ? 0 : orderSummary.orderShipped }</h5>
                                                </div>
                                                <div>
                                                    <p>Orders Shipped</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Button>
                                    <Button className={'order-group-link'} stylingMode={'outlined'} width={170}>
                                        <div className={'order-item'}>
                                            <div className={'img-box'}>
                                                <i className="fas fa-boxes fa-2x dark-blue-icon"></i>
                                            </div>
                                            <div className={'statistic-no'}>
                                                <div>
                                                    <h5>{(orderSummary.totalOrder === undefined) ? 0 : orderSummary.totalOrder }</h5>
                                                </div>
                                                <div>
                                                    <p>Total Orders</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Button>
                                </div>
                            </Item>
                        </TabPanel>
                    </div>
                    <div className={'order'}>
                        <div className={'bar-chart-area mb-2 mr-2'}>
                            <div className={'flex-row flex-between'}>
                                <h5 className={'m_2'}>Total Orders</h5>
                            </div>
                            <TabPanel className={'tab'}>
                                <Item className={'item'} title="TODAY">
                                    <Chart className={'bar-chart'} dataSource={totalOrderWeekMonth.totalOrdersToday} palette="Soft Pastel">
                                        <CommonSeriesSettings
                                            argumentField="storeName"
                                            valueField="orderTotal"
                                            type="bar"
                                            ignoreEmptyPoints={true}/>
                                        <SeriesTemplate nameField="storeName"/>
                                        <Legend
                                            visible={false}
                                            verticalAlignment="bottom"
                                            horizontalAlignment="center"/>
                                    </Chart>
                                </Item>
                                <Item className={'item'} title="WEEK">
                                    <Chart className={'bar-chart'} dataSource={totalOrderWeekMonth.totalOrderinWeek} palette="Soft Pastel">
                                        <CommonSeriesSettings
                                            argumentField="date"
                                            type="bar"
                                            hoverMode="allArgumentPoints"
                                            selectionMode="allArgumentPoints"/>
                                        <Series argumentField="date" valueField="amazonCo" name="amazonCo"/>
                                        <Series argumentField="date" valueField="ebayCo" name="ebayCo"/>
                                        <Series argumentField="date" valueField="etsyCo" name="etsyCo"/>
                                        <Series argumentField="date" valueField="shopifyCo" name="shopifyCo"/>
                                        <Series argumentField="date" valueField="aliExpressCo" name="aliExpressCo"/>
                                        <Series argumentField="date" valueField="Manual Orders" name="Manual Orders"/>
                                        <Legend verticalAlignment="bottom" horizontalAlignment="center"/>
                                    </Chart>
                                </Item>
                                <Item className={'item'} title="MONTH">
                                    <Chart className={'bar-chart'} dataSource={totalOrderWeekMonth.totalOrderMonth} palette="Soft Pastel">
                                        <CommonSeriesSettings
                                            argumentField="date"
                                            type="bar"
                                            hoverMode="allArgumentPoints"
                                            selectionMode="allArgumentPoints"/>
                                        <Series argumentField="date" valueField="amazon" name="amazon"/>
                                        <Series argumentField="date" valueField="ebay" name="ebay"/>
                                        <Series argumentField="date" valueField="etsy" name="etsy"/>
                                        <Series argumentField="date" valueField="shopify" name="shopify"/>
                                        <Series argumentField="date" valueField="aliExpress" name="aliExpress"/>
                                        <Legend verticalAlignment="bottom" horizontalAlignment="center"/>
                                    </Chart>
                                </Item>
                                <Item className={'item'} title="YEAR">
                                    <Chart className={'bar-chart'} palette="Soft Pastel">
                                        <CommonSeriesSettings
                                            argumentField="date"
                                            type="bar"
                                            hoverMode="allArgumentPoints"
                                            selectionMode="allArgumentPoints"/>
                                        <Series argumentField="date" valueField="amazon" name="amazon"/>
                                        <Series argumentField="date" valueField="ebay" name="ebay"/>
                                        <Series argumentField="date" valueField="etsy" name="etsy"/>
                                        <Series argumentField="date" valueField="shopify" name="shopify"/>
                                        <Series argumentField="date" valueField="aliExpress" name="aliExpress"/>
                                        <Legend verticalAlignment="bottom" horizontalAlignment="center"/>
                                    </Chart>
                                </Item>
                            </TabPanel>
                        </div>
                        <div className={'sales-percentage mb-2'}>
                            <h7 className={'mb-2'}>Sales By Stores</h7>
                            <StoresProgressBar items={salesByStore} />
                        </div>
                    </div>
                    <div className={'shipments'}>
                        <div className={'pie-chart-area mb-2 mr-2'}>
                            <h7 className={'m_2'}>Shipments By Carrier</h7>
                            <PieChart
                                className={'pie-chart'}
                                dataSource={shipmentByCarrier}
                                id="pie"
                                type="doughnut"
                                palette="Soft Pastel">
                                <PieChartSeries argumentField="_id">
                                    <Label visible={true}>
                                        <Connector visible={true}/>
                                    </Label>
                                </PieChartSeries>
                                <Export enabled={false}/>
                                <PieChartLegend margin={0} horizontalAlignment="right" verticalAlignment="top"/>
                                <Tooltip enabled={true} customizeTooltip={customizeTooltip}></Tooltip>
                                <Legend verticalAlignment="bottom" horizontalAlignment="center"/>
                            </PieChart>
                        </div>
                        <div className={'top-products'}>
                            <h7 className={'m_2'}>Top 5 Products by Revenue</h7>
                            <Customers dataProduct={topProduct}/>
                        </div>
                    </div>
                </div>
                <div className={'notifications mb-2'}>
                    <h7 className={'mt-2'}>Upcoming Deadlines</h7>
                    <LoadIndicator
                        visible={loadingIndicator}
                        height={40}
                        width={40}
                    />
                    <Calendar
                        value={currentDate}
                        onValueChanged={calendarValueChanged} 
                        id="calendar-container" 
                        width={'90%'}/>
                    <List
                        className={'upcoming-deadline-list'}
                        dataSource={dataUpcomingEvent}
                        itemRender={NotificationWrap}
                        height={500}
                        />
                </div>
            </div>

        </React.Fragment>
    )
}

export default Overview;
